import React, { useState } from 'react';

const Services = () => {
  const [active, setActive] = useState('DigitalServices');
  const [isHovered, setIsHovered] = useState(false);

  const content = {
    DigitalServices: [
      // Software Development
      {
        title: 'Digital Services',
        models: [
          {
            description: 'Software Development',
            link: {
              url: '/Software',
            },
          },
          {
            description: 'Networking',
            link: {
              url: '/Network',
            },
          },
          {
            description: 'IT Support Services',
            link: {
              url: '/ITSupport',
            },
          },
          {
            description: 'CCTV Services',
            link: {
              url: '/CCTV',
            },
          },
        ],
      },
    ],
    CloudServices: [
      {
        title: 'Cloud Services',
        models: [
          {
            description: 'Backup & Disaster Recovery',
            link: {
              url: '/ServicesHome',
            },
          },
          {
            description: 'Cloud Application Backup',
            link: {
              url: '/ServicesHome',
            },
          },
          {
            description: 'Cloud Backup',
            link: {
              url: '/ServicesHome',
            },
          },
          {
            description: 'Software as a Service (SaaS)',
            link: {
              url: '/ServicesHome',
            },
          },
        ],
      },
    ],
    hosting: [
      {
        title: 'Hosting Services',
        models: [
          {
            description: 'Virtual Private Server (VPS) Hosting',
            link: {
              url: '/ServicesHome',
            },
          },
          {
            description: 'Database Hosting',
            link: {
              url: '/ServicesHome',
            },
          },
          {
            description: 'Cloud Hosting',
            link: {
              url: '/ServicesHome',
            },
          },
          {
            description: 'Email Hosting',
            link: {
              url: '/ServicesHome',
            },
          },
        ],
      },
    ],
  };

  const handleServiceClick = (url) => {
    window.location.href = url; // Navigate to the service page
    window.close();             // Close the current window
  };

  return (
    <div className="relative group">
      <div 
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
      >
        <button
          className={`relative px-2 py-2 text-gray-600 bg-white rounded ease-in-out transform focus:outline-none font-normal 
            after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[2px] after:transition-all after:duration-3000 
            ${isHovered ? 'hover:scale-110 after:bg-blue-500 after:w-full' : 'after:bg-transparent'}`}
        >
          Services
        </button>
        <div className="fixed center transform lg:-translate-x-1/2 sm:-center-x-1/2 mt-0.5 bg-white rounded-md hidden group-hover:block text-justify w-full sm:w-9/12 lg:max-w-900px z-50 overflow-y-auto max-h-[80vh]">
          <div className="p-4 flex flex-col lg:flex-row text-justify h-auto lg:h-68vh">
            {/* Options on the left */}
            <div className="flex-shrink-0 mt-8 flex lg:flex-col overflow-x-auto lg:overflow-visible">
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] font-normal ${active === 'DigitalServices' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('DigitalServices')}
              >
                Digital Services
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'CloudServices' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('CloudServices')}
              >
                Cloud Services 
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'hosting' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('hosting')}
              >
                Hosting Services
              </button>
            </div>
            {/* Vertical rule */}
            <div className="border-l border-gray-300 h-auto mx-4 hidden lg:block"></div>
            {/* Content on the right */}
            <div className="flex-grow p-4 overflow-x-auto lg:overflow-visible">
              <div className="flex flex-wrap lg:flex-nowrap lg:space-x-4">
                {content[active].map((item, index) => (
                  <div key={index} className="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                    <div className="p-4">
                      <h3 className="text-lg text-gray-600 font-normal">{item.title}</h3>
                      <hr /> <br />
                      {item.models.map((model, idx) => (
                        <div key={idx} className="mb-2">
                          <p
                            onClick={() => handleServiceClick(model.link.url)}
                            className="text-gray-500 hover:text-blue-900 text-md font-normal cursor-pointer"
                          >
                            {model.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
